import { render, staticRenderFns } from "./pointShop.vue?vue&type=template&id=e93645be&scoped=true&"
import script from "./pointShop.vue?vue&type=script&lang=js&"
export * from "./pointShop.vue?vue&type=script&lang=js&"
import style0 from "./pointShop.vue?vue&type=style&index=0&id=e93645be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93645be",
  null
  
)

export default component.exports